import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { WebLink } from '@/components/functional/Link/WebLink';
import { AngleRightIcon } from '@/components/ui/SvgIcon/Variable/SvgIconComponents';
import { Text } from '@/components/ui/Typography/Body/Text';
import { companyPath, lawPath, privacyPath, termsPath, termsProffitSearchPath, } from '@/utils/router/links';
const pageList = [
    { text: '会社概要', to: companyPath() },
    { text: '利用規約', to: termsPath() },
    { text: 'PROFFIT SEARCH 利用規約', to: termsProffitSearchPath() },
    { text: '特定商取引法', to: lawPath() },
    { text: 'プライバシーポリシー', to: privacyPath() },
];
/**
 * サイドメニューにバナー表示をするためのコンポーネント
 * @param props
 * @returns
 */
export const SideMenuPages = (props) => {
    const { activePath, className = '' } = props;
    return (_jsx("div", Object.assign({ className: clsx(className) }, { children: _jsx("ul", Object.assign({ className: 'flex flex-col' }, { children: pageList.map((page) => (_jsx("li", Object.assign({ className: clsx('flex items-center', 'w-full') }, { children: _jsxs(WebLink, Object.assign({ className: clsx('group', 'w-full h-[56px]', 'flex justify-between items-center', 'border-0 border-b border-solid', activePath === page.to ? 'border-navy-100' : 'border-gray-300'), disabled: activePath === page.to, to: page.to }, { children: [_jsx(Text, Object.assign({ className: clsx(activePath !== page.to && 'group-hover:text-link'), color: 'primary' }, { children: page.text })), _jsx("div", Object.assign({ className: 'block h-[16px]' }, { children: _jsx(AngleRightIcon, { className: clsx(activePath !== page.to && 'group-hover:text-link'), color: 'primary', size: 'sm' }) }))] })) }), page.text))) })) })));
};
